<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<template>
  <div class="main-filters">
    <div class="title-primary">Filtros</div>
    <div class="row">
      <div class="col-md-3">
        <div class="title-filters">ID</div>
        <div class="baseline_box mb-2">
          <Input
            label=""
            type="number"
            name="license_id"
            :value="valuesFilter.license_id"
            @input="(event) => (valuesFilter.license_id = event.target.value)"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="title-filters">Aprobaciones con tiquetes</div>
        <div class="baseline_box mb-2">
          <Select
            label=""
            name="name"
            :options="optionsTicketType"
            :value="valuesFilter.selectTicketType"
            :required="false"
            :disabled="false"
            v-model="valuesFilter.selectTicketType"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="title-filters">Gestión de tiquetes</div>
        <div class="baseline_box mb-2">
          <Select
            label=""
            name="name"
            :options="optionsManagement"
            :value="valuesFilter.selectManagement"
            :required="false"
            :disabled="false"
            v-model="valuesFilter.selectManagement"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="title-filters">Aprobación</div>
        <div class="baseline_box mb-2">
          <Select
            label=""
            name="name"
            :options="optionsTypeManagement"
            :value="valuesFilter.selectTypeManagement"
            :required="false"
            :disabled="false"
            v-model="valuesFilter.selectTypeManagement"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="title-filters">Fecha</div>
        <div class="mb-2">
          <div class="pt-4 space-y-4">
            <Date
              name="start_date"
              label="Inicio"
              v-model="valuesFilter.start_date"
              :value="valuesFilter.start_date"
              :max="valuesFilter.end_date"
            />
            <Date
              name="end_date"
              label="Fin"
              v-model="valuesFilter.end_date"
              :value="valuesFilter.end_date"
              :min="valuesFilter.start_date"
            />
          </div>
        </div>
      </div>
      <div class="col clear-filters" v-if="isDisabled">
        <button class="button-danger" @click.prevent="clearFilters">
          Quitar todos los filtros
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./styles.scss" />
